import axios from 'axios';
const instance = axios.create({
  timeout: 90000,
  // withCredentials: true,
});
import { getConsumerId } from './utils';
instance.interceptors.request.use(
  (config) => {
    // config.headers['Site-Consumerid'] = getConsumerId();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.resolve(error.response);
  }
);
export {
  instance as HttpRequest
} 